import script from "./PressureTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PressureTable.vue?vue&type=script&setup=true&lang=ts"

import "./PressureTable.vue?vue&type=style&index=0&id=49aa0aa1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49aa0aa1"]])

export default __exports__